// This needs to restructured

export const SYSTEM_ERROR_MESSAGE_SHORTCUT_CODES = {
    code1: 16,
    type1: 'isShift',
    code2: 17,
    type2: 'isCtrl',
    code3: 69,
    type3: 'isE'
};

export const KEYBOARD_KEYS_CODE_NAME = {
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    BACKSPACE: 'Backspace',
    DELETE: 'Delete',
    HOME: 'Home',
    END: 'End',
};